import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import type Message from 'owa-service/lib/contract/Message';
import { userDate, compare } from 'owa-datetime';

/**
 * Compares two search results
 * @param {SearchResultItem} item1 first result to compare
 * @param {SearchResultItem} item2 second result to compare
 * @returns positive number if item1 > item2, otherwise returns negative number
 */
export default function compareAssets(item1: SearchResultItem, item2: SearchResultItem): number {
    if (item1.type !== item2.type) {
        // cannot compare items of 2 different types
        return 0;
    }

    const messageItem1 = item1.data as Message;
    const messageItem2 = item2.data as Message;

    // sort by message received time
    const parsedDate1 = userDate(messageItem1.DateTimeReceived as string);
    const parsedDate2 = userDate(messageItem2.DateTimeReceived as string);

    // reverse 2 and 1 because we want sorted top down
    return compare(parsedDate2, parsedDate1);
}
